// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

/**
 * Which way an alert says glucose is going, by AlertEvents.alertType — the ONE
 * mapping for every alert surface's direction icon and click-through
 * (eng-brain P70-4). The three surfaces each carried a copy of a switch on
 * 'hypoglycemia' / 'hyperglycemia', values ada-core never stores, and all
 * three missed warning_hypoglycemia (one of the two types enabled in prod).
 * Keyed on the server's option values (ada-core src/collections/AlertEvents).
 */
const DIRECTION: ReadonlyMap<string, 'down' | 'up'> = new Map([
  ['critical_hypoglycemia', 'down'],
  ['warning_hypoglycemia', 'down'],
  ['rapid_drop', 'down'],
  ['critical_hyperglycemia', 'up'],
  ['warning_hyperglycemia', 'up'],
  ['postprandial_spike', 'up'],
])

export const glucoseDirection = (alertType: string | null | undefined): 'down' | 'up' | null =>
  (alertType && DIRECTION.get(alertType)) || null
